import { StarredDatedEvent } from './starred-dated-event.model';

export enum ParticipationType {
  Invalid = 0,
  Attended = 1,
  Conducted = 2
}

export interface Course extends StarredDatedEvent {
  participationType: ParticipationType;
} 